<div class="legal-page">
  <div class="legal-inner">
    <header class="legal-head">
      <h1>Informativa sulla privacy</h1>
      <p class="legal-updated">Ultimo aggiornamento: ottobre 2026</p>
    </header>

    <section class="legal-panel">
      <h2>1. Titolare del trattamento</h2>
      <p>
        Il titolare del trattamento dei dati personali è la
        <strong>Confraternita di Misericordia di Borgo San Lorenzo</strong>
        (di seguito anche “Misericordia” o “Titolare”), con sede in
        Via Giotto, 34 — 50032 Borgo San Lorenzo (FI), P. IVA 01343220487.
      </p>
      <p>
        Per richieste relative alla privacy è possibile contattare il Titolare
        all’indirizzo email
        <a href="mailto:home@misericordia.net">home&#64;misericordia.net</a>,
        alla PEC
        <a href="mailto:misericordiabsl@legalmail.it">misericordiabsl&#64;legalmail.it</a>
        oppure al telefono
        <a href="tel:0558494118">055 8494118</a>.
      </p>
    </section>

    <section class="legal-panel">
      <h2>2. Ambito di questa informativa</h2>
      <p>
        Questa informativa descrive il trattamento dei dati personali effettuato
        attraverso il sito dell’Archivio della Misericordia di Borgo San Lorenzo
        (navigazione pubblica, richiesta di accesso, autenticazione degli utenti
        autorizzati e consultazione dei contenuti dell’archivio).
      </p>
      <p>
        I trattamenti relativi ai pagamenti online (quote, lampade votive,
        donazioni) sono descritti in una
        <a routerLink="/pagamenti/privacy">informativa dedicata</a>.
      </p>
    </section>

    <section class="legal-panel">
      <h2>3. Tipologie di dati trattati</h2>
      <p>A seconda delle funzioni utilizzate, possono essere trattati:</p>
      <ul>
        <li>
          dati di navigazione tecnici (ad esempio indirizzo IP, data e ora di
          accesso, informazioni sul dispositivo e sul browser) necessari al
          funzionamento e alla sicurezza del servizio;
        </li>
        <li>
          dati anagrafici e di contatto forniti in fase di registrazione o
          richiesta di accesso (nome, cognome, indirizzo email e, ove richiesti,
          ulteriori informazioni utili alla valutazione della richiesta);
        </li>
        <li>
          credenziali e dati di autenticazione necessari all’accesso alle aree
          riservate;
        </li>
        <li>
          dati relativi all’attività svolta nell’area riservata (ad esempio
          operazioni di consultazione o gestione dei contenuti), nei limiti
          necessari a erogare il servizio e a garantirne la sicurezza.
        </li>
      </ul>
      <p>
        Non sono richiesti dati particolari (ai sensi dell’art. 9 GDPR) per la
        semplice navigazione del sito. Qualora contenuti documentali
        dell’archivio contengano dati personali storici, il trattamento avviene
        per finalità di archiviazione nel pubblico interesse, studio e ricerca
        storica, nel rispetto della normativa applicabile.
      </p>
      <p>
        Le riproduzioni di documenti e immagini dell’Archivio sono tutelate e
        il loro utilizzo è regolato dalle
        <a routerLink="/condizioni-uso">Condizioni d’uso e diritti sulle immagini</a>,
        non dalla presente informativa privacy.
      </p>
    </section>

    <section class="legal-panel">
      <h2>4. Finalità e basi giuridiche</h2>
      <h3>Funzionamento del sito e sicurezza</h3>
      <p>
        I dati tecnici di navigazione e le misure di sicurezza sono trattati per
        consentire la fruizione del sito, prevenire abusi e garantire l’integrità
        del servizio (interesse legittimo del Titolare e, ove applicabile,
        adempimento di obblighi di legge).
      </p>

      <h3>Richiesta di accesso e gestione account</h3>
      <p>
        I dati forniti per richiedere l’accesso o gestire un account sono
        trattati per esaminare la richiesta, autenticare l’utente e consentire
        l’uso delle funzioni autorizzate (esecuzione di misure precontrattuali o
        del rapporto con l’utente; interesse legittimo alla gestione sicura
        degli accessi).
      </p>

      <h3>Consultazione e gestione dell’archivio</h3>
      <p>
        I dati connessi all’uso dell’area riservata sono trattati per fornire i
        servizi di consultazione e, per gli utenti autorizzati, di gestione dei
        contenuti (esecuzione del servizio richiesto e interesse legittimo del
        Titolare).
      </p>

      <h3>Adempimenti di legge</h3>
      <p>
        Ove necessario, i dati possono essere trattati per assolvere obblighi
        previsti dalla normativa vigente.
      </p>
    </section>

    <section class="legal-panel">
      <h2>5. Modalità del trattamento e sicurezza</h2>
      <p>
        I dati sono trattati con strumenti informatici e organizzativi adeguati,
        adottando misure ragionevoli per proteggerli da accessi non autorizzati,
        perdita o uso improprio. L’accesso alle aree riservate è limitato agli
        utenti autorizzati.
      </p>
      <p>
        Per motivi di sicurezza, in questa informativa non sono descritti
        dettagli tecnici sull’infrastruttura o sulle misure di protezione
        adottate.
      </p>
    </section>

    <section class="legal-panel">
      <h2>6. Conservazione</h2>
      <p>
        I dati sono conservati per il tempo strettamente necessario alle
        finalità per cui sono stati raccolti:
      </p>
      <ul>
        <li>
          dati di navigazione tecnica: per periodi brevi, salve esigenze di
          accertamento di illeciti o sicurezza;
        </li>
        <li>
          dati di account e autenticazione: per la durata del rapporto e, dopo
          la cessazione, per il tempo richiesto da obblighi di legge o da
          esigenze di tutela del Titolare;
        </li>
        <li>
          richieste di accesso non accolte: per il tempo necessario alla
          gestione della pratica e a eventuali verifiche successive.
        </li>
      </ul>
    </section>

    <section class="legal-panel">
      <h2>7. Destinatari e trasferimenti</h2>
      <p>
        I dati possono essere conosciuti da personale autorizzato della
        Misericordia e, se necessario, da fornitori di servizi tecnici che
        operano per conto del Titolare (ad esempio hosting o manutenzione),
        vincolati a obblighi di riservatezza e istruzioni sul trattamento.
      </p>
      <p>
        I dati non sono diffusi. Eventuali trasferimenti fuori dallo Spazio
        Economico Europeo, se presenti, avvengono solo con garanzie adeguate
        previste dalla normativa.
      </p>
    </section>

    <section class="legal-panel">
      <h2>8. Cookie e memorizzazioni locali</h2>
      <p>
        Il sito può utilizzare cookie tecnici e memorizzazioni locali
        strettamente necessari al funzionamento (ad esempio per mantenere la
        sessione di accesso e ricordare la presa visione del banner informativo).
        Maggiori dettagli sono disponibili nella
        <a routerLink="/cookie">Cookie Policy</a>.
      </p>
    </section>

    <section class="legal-panel">
      <h2>9. Diritti dell’interessato</h2>
      <p>
        Nei limiti previsti dal Regolamento (UE) 2016/679 (GDPR), l’interessato
        può chiedere al Titolare: accesso, rettifica, cancellazione, limitazione,
        opposizione e, ove applicabile, portabilità dei dati. Può inoltre
        proporre reclamo all’Autorità Garante per la protezione dei dati
        personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a>).
      </p>
      <p>
        Le richieste possono essere inviate ai recapiti indicati al punto 1.
      </p>
    </section>

    <section class="legal-panel">
      <h2>10. Aggiornamenti</h2>
      <p>
        La presente informativa può essere aggiornata per adeguamenti normativi
        o modifiche ai servizi. La versione aggiornata è pubblicata su questa
        pagina con indicazione della data di revisione.
      </p>
    </section>
  </div>
</div>
